import { ToastContainer } from 'react-toastify';

import { CssBaseline, ThemeProvider } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { AppRouter } from './routers/AppRouter';
import { AppLayout } from './styles/common';
import { theme } from './styles/theme';

import "react-day-picker/style.css";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <AppLayout>
          <ToastContainer
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            pauseOnHover
            pauseOnFocusLoss
          />
          <AppRouter />
        </AppLayout>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;
